import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import clsx from "clsx";

import {getHiddenContainerState, setHiddenContainerState} from "../../../slices/UserSlice";
import ToolTip, {TOOLTIP_PLACEMENT} from "../../../utilities/ToolTip";

import "./hiddenContent.scss";

const HiddenContainer = ({
  children,
  tooltipMessageShow, //when content is hidden
  tooltipMessageHide, //when content is shown
  contentTooltipTitle,
  window,
  isShown = false,
  setIsShown,
  vertical = false, //by default is horizontal, can be changed to vertical
  pulseAnimation = false, //animated toggle btn
  className,
  contentClassName,
  style = {},
  hidden,
}) => {
  const [showContent, setShowContent] = useState(isShown);

  useEffect(() => {
    setShowContent(isShown);
  }, [isShown]);

  const {t} = useTranslation();
  const initialState = useSelector(getHiddenContainerState);
  const dispatch = useDispatch();
  useEffect(() => {
    if (window) {
      if (initialState?.[window]) {
        setShowContent(initialState?.[window]);
      }
    }
  }, []);

  useEffect(() => {
    if (window) dispatch(setHiddenContainerState({window, value: showContent}));
  }, [showContent]);

  return (
    <div
      className={clsx(vertical ? "hiddenVerticalContainer pl5" : "hiddenContainer", className, hidden && "hiddenEl")}
      style={{...style, width: showContent ? style?.width : vertical && "0px"}}
    >
      <ToolTip
        title={contentTooltipTitle || ""}
        className={clsx("content", showContent && "show", showContent && contentClassName)}
      >
        <>{showContent && children}</>
      </ToolTip>
      <div className="fc jcc" style={{marginTop: "-5px"}}>
        <ToolTip
          title={showContent ? t(tooltipMessageHide) || t(tooltipMessageShow) : t(tooltipMessageShow)}
          className={clsx(vertical && "toggle-tooltip")}
          placement={vertical && TOOLTIP_PLACEMENT.LEFT}
        >
          <button
            type="button"
            className={clsx("toggle-button", pulseAnimation && "hiddenContainerPulse")}
            onClick={() => {
              if (setIsShown && typeof setIsShown === "function") {
                setIsShown(prev => !prev);
                return;
              }
              setShowContent(prev => !prev);
            }}
          >
            <div className="toggle-inner">
              <span>{showContent ? "▲" : "▼"}</span>
            </div>
          </button>
        </ToolTip>
      </div>
    </div>
  );
};

export default HiddenContainer;
